import { render, staticRenderFns } from "./TheCartConfirm.vue?vue&type=template&id=1f60b0c9&"
import script from "./TheCartConfirm.vue?vue&type=script&lang=js&"
export * from "./TheCartConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports